import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AiChatPage } from '@/pages/ai-chat';
import { RoleGuard } from '@/components/molecules/role-guard';
import { usePermissions } from '@/hooks/use-permissions';

const artifactTypes = [
  'cashFlowOverview',
  'categoryOverview',
  'costDriver',
  'categoryExpense',
  'categoryIncome',
  'timeSeries',
  'categoryBreakdown',
  'categoryBar',
  'accountBreakdown',
  'forecastTimeline',
  'documentSummary',
  'documentTimeline',
  'workingCapitalRisk',
  'documentAging',
  'dscrCompliance',
  'kpiMetrics',
  'progressOverview',
  'ranking',
  'trendComparison',
] as const;

const searchSchema = z.object({
  artifact: z.enum(artifactTypes).optional(),
  period: z.string().optional(),
  chatDomain: z.enum(['help', 'finance']).optional(),
});

function AiChatRoute() {
  const { canUseAI, isLoading } = usePermissions();

  return (
    <RoleGuard hasAccess={canUseAI} isLoading={isLoading}>
      <AiChatPage />
    </RoleGuard>
  );
}

export const Route = createFileRoute('/protected/_layout/ai-chat')({
  validateSearch: searchSchema,
  component: AiChatRoute,
});
